export default {
    h5: {
        personalCertificate:
            "/gateway/huilianCust/businessPermissioncs/personalCertificate", //个人实名认证
        getPersonalFaceCaUrl:
            "/gateway/huilianCust/realCustcs/getPersonalFaceCaUrl", //人脸认证
    },
    wechat: {
        personalCertificate:
            "/gateway/huilianCust/businessPermissioncs/personalCertificate", //个人实名认证
        getPersonalFaceCaUrl:
            "/gateway/huilianCust/realCustcs/getPersonalFaceCaUrl", //人脸认证
    },
};



// WEBPACK FOOTER //
// ./src/authCertificate/ACPersonalPapers/api.js